import { css } from 'styled-components';
import { cardWidths } from 'modules/journey/card/styled';

const titleStyles = css`
  ${cardWidths}
  display: flex;
  align-items: center;
  font-size: 20px;
  height: 38px;

  .title {
    margin: 0 8px 0 0;
    display: block;
    font-size: inherit;
  }
`;

export default titleStyles;
